export default function finalIframeValue(props, { baseUrl, urlParams, regex }) {
  // const query = new URLSearchParams(urlParams);
  // const queryJoiner = baseUrl.indexOf("?") >= 0 ? "&" : "?";

  let finalSrc = props.src.replace(regex, baseUrl);

  if (urlParams) {
    const query = new URLSearchParams(urlParams);
    const queryJoiner = baseUrl.indexOf('?') >= 0 ? '&' : '?';
    finalSrc = finalSrc + queryJoiner + query;
  }

  return finalSrc;
}
